export enum ReviewsFilterType {
  BUSINESS = 'Business',
  BUSINESS_LEISURE = 'Biz_Leisure',
  PARTNER = 'Partner',
  FAMILY = 'Family',
  FAMILY_WITH_CHILDREN = 'Family_with_children',
  SELF = 'Self',
  FRIENDS = 'Friends',
  PET = 'Pet'
}

export enum TravelerTypeOptions {
  FAMILIES = 'families',
  FAMILIES_WITH_CHILDREN = 'families_with_small_children',
  BUSINESS_TRAVELERS = 'business_travelers',
  COUPLES = 'couples',
  SOLO_TRAVELERS = 'solo_travelers',
  GROUPS = 'groups',
  TRAVELERS_WITH_PETS = 'travelers_with_pets'
}
